import { IBaseAsyncSelectInputProps } from '@framework/form';
import React from 'react';
import { FrontCategoryAsyncSelectInput } from '../../../submission/filter/FrontCategoryAsyncSelectInput';

export interface IInquiryCategorySelectInputProps
  extends IBaseAsyncSelectInputProps {}

/**
 * Input per la selezione della categoria di una domanda.
 */
export function InquiryCategorySelectInput(
  props: IInquiryCategorySelectInputProps,
) {
  return <FrontCategoryAsyncSelectInput {...props} style={{ width: '100%' }} />;
}
